export const setLocalStorage = async (key, value) => {
    if (!key || typeof key !== 'string')
        return

    let strValue = ''
    if (value) {
        strValue = JSON.stringify(value)
    }

    window.localStorage.setItem(key, strValue)
}

export const getLocalStorage = (key) => {
    if (!key || typeof key !== 'string')
        return null

    const strValue = window.localStorage.getItem(key)
    if (!strValue)
        return null

    const objValue = JSON.parse(strValue)
    return objValue
}

export const removeLocalStorage = (key) => {
    if (!key || typeof key !== 'string')
        return

    window.localStorage.removeItem(key)
}

export const localStorageSupported = () => {
    return window.localStorage !== 'undefined'
}
